import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Navclose from "../../assets/Svg/Nav_Close_Svg"; // Make sure this is imported
import Navhome from "../../assets/Svg/Navhome_Svg";
import Navabout from "../../assets/Svg/Navabout_Svg";
import Navservices from "../../assets/Svg/Navservices_Svg";
import Styles from "../CSS/Sidebar.module.css";

const Sidebar = ({ onClose, show }) => {
 const [screenWidth, setScreenWidth] = useState(window.innerWidth);
 const [screenHeight, setScreenHeight] = useState(window.innerHeight);
 const handleResize = () => {
  setScreenWidth(window.innerWidth);
  setScreenHeight(window.innerHeight);
 };

 useEffect(() => {
  window.addEventListener("resize", handleResize);

  return () => {
   window.removeEventListener("resize", handleResize);
  };
 }, []);

 return (
  <div>
   {show && (
    <div
     // style={{
     //  position: "fixed",
     //  top: show ? "8vh" : "-100%",
     //  width: "100%",
     //  height: "30vh",
     //  backgroundColor: "#4C4C4C",
     //  display: "flex",
     //  justifyContent: "center",
     //  alignItems: "center",
     //  flexDirection: "column",
     //  transition: "top 0.3s ease",
     //  zIndex: 1000,
     // }}
     className={Styles.cont1}
    >
     {/* <div 
        style={{ 
          position: 'absolute', 
          top: '15px', 
          right: '15px', 
          cursor: 'pointer' 
        }}
        onClick={onClose} 
      >
        <Navclose />
      </div> */}

     <Link
      to="/"
      // style={{
      //  width: "28%",
      //  height: "6vh",
      //  display: "flex",
      //  justifyContent: "space-between",
      //  alignItems: "center",
      //  textDecoration: "none",
      //  color: "#000000",
      //  fontSize: "20px",
      // }}

      className={Styles.listText}
      onClick={(e) => {
       e.stopPropagation();
       onClose();
       window.scrollTo(0, 0);
      }}
     >
      <div className={Styles.svgCont}>
       <Navhome />
      </div>
      <div className={Styles.textContainer}>Home</div>
     </Link>

     <Link
      to="/about"
      className={Styles.listText}
      // style={{
      //  width: "28%",
      //  height: "6vh",
      //  display: "flex",
      //  justifyContent: "space-between",
      //  alignItems: "center",
      //  textDecoration: "none",
      //  color: "#000000",
      //  fontSize: "20px",
      // }}
      onClick={(e) => {
       e.stopPropagation();
       onClose();
       window.scrollTo(0, 0);
      }}
     >
      <div className={Styles.svgCont}>
       <Navabout />
      </div>
      <div className={Styles.textContainer}>About</div>
     </Link>

     <Link
      to="/services"
      className={Styles.listText}
      // style={{
      //  width: "28%",
      //  height: "6vh",
      //  display: "flex",
      //  justifyContent: "space-between",
      //  alignItems: "center",
      //  textDecoration: "none",
      //  color: "#000000",
      //  fontSize: "20px",
      // }}
      onClick={(e) => {
       e.stopPropagation();
       onClose();
       window.scrollTo(0, 0);
      }}
     >
      <div className={Styles.svgCont}>
       {" "}
       <Navservices />{" "}
      </div>

      <div className={Styles.textContainer}> Services </div>
     </Link>
    </div>
   )}

   {!show && (
    <div
     // style={{
     //  position: "fixed",
     //  top: show ? "8vh" : "-100%",
     //  width: "100%",
     //  height: "30vh",
     //  backgroundColor: "#4C4C4C",
     //  display: "flex",
     //  justifyContent: "center",
     //  alignItems: "center",
     //  flexDirection: "column",
     //  transition: "top 0.3s ease",
     //  zIndex: 1000,
     // }}
     className={Styles.cont2}
    >
     {/* <div 
         style={{ 
           position: 'absolute', 
           top: '15px', 
           right: '15px', 
           cursor: 'pointer' 
         }}
         onClick={onClose} 
       >
         <Navclose />
       </div> */}

     {/* <Link
      to="/"
      style={{
       width: "28%",
       height: "6vh",
       display: "flex",
       justifyContent: "space-between",
       alignItems: "center",
       textDecoration: "none",
       color: "#000000",
       fontSize: "20px",
      }}
      onClick={(e) => {
       e.stopPropagation();
       onClose();
       window.scrollTo(0, 0);
      }}
     >
      <Navhome /> Home
     </Link>

     <Link
      to="/about"
      style={{
       width: "28%",
       height: "6vh",
       display: "flex",
       justifyContent: "space-between",
       alignItems: "center",
       textDecoration: "none",
       color: "#000000",
       fontSize: "20px",
      }}
      onClick={(e) => {
       e.stopPropagation();
       onClose();
       window.scrollTo(0, 0);
      }}
     >
      <Navabout />
      About
     </Link>

     <Link
      to="/services"
      style={{
       width: "28%",
       height: "6vh",
       display: "flex",
       justifyContent: "space-between",
       alignItems: "center",
       textDecoration: "none",
       color: "#000000",
       fontSize: "20px",
      }}
      onClick={(e) => {
       e.stopPropagation();
       onClose();
       window.scrollTo(0, 0);
      }}
     >
      <Navservices /> Services
     </Link> */}
    </div>
   )}
  </div>
 );
};

export default Sidebar;
